import React from 'react';
import {
  FaPlus,
  FaEdit,
  FaBan,
  FaUndo,
  FaArrowUp,
  FaBell,
  FaCalendarAlt,
  FaMoneyBillWave,
  FaExclamationTriangle,
  FaUserPlus,
  FaUserEdit,
  FaUserMinus,
  FaSyncAlt,
  FaFileSignature,
  FaCircle,
} from 'react-icons/fa';
import style from './AuditLogTimeline.module.css';

// Metadatos por acción: etiqueta, color e ícono.
const ACTION_META = {
  create: { label: 'Creación', color: '#10b981', Icon: FaPlus },
  update: { label: 'Actualización', color: '#3b82f6', Icon: FaEdit },
  cancel: { label: 'Cancelación', color: '#ef4444', Icon: FaBan },
  reactivate: { label: 'Reactivación', color: '#10b981', Icon: FaUndo },
  adjustment: { label: 'Ajuste', color: '#f59e0b', Icon: FaArrowUp },
  adjustment_notified: { label: 'Ajuste notificado', color: '#f59e0b', Icon: FaBell },
  payment_schedule: { label: 'Cronograma', color: '#6366f1', Icon: FaCalendarAlt },
  payment_register: { label: 'Pago registrado', color: '#10b981', Icon: FaMoneyBillWave },
  payment_overdue_run: { label: 'Actualización de mora', color: '#ef4444', Icon: FaExclamationTriangle },
  tenant_add: { label: 'Inquilino agregado', color: '#3b82f6', Icon: FaUserPlus },
  tenant_update: { label: 'Inquilino actualizado', color: '#3b82f6', Icon: FaUserEdit },
  tenant_delete: { label: 'Inquilino eliminado', color: '#ef4444', Icon: FaUserMinus },
  renew: { label: 'Renovación', color: '#8b5cf6', Icon: FaSyncAlt },
  contract_signed: { label: 'Contrato firmado', color: '#10b981', Icon: FaFileSignature },
};

const getMeta = (action) =>
  ACTION_META[action] || { label: action || 'Operación', color: '#6b7280', Icon: FaCircle };

const formatDateTime = (d) => {
  if (!d) return '-';
  try {
    return new Date(d).toLocaleString('es-AR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return String(d);
  }
};

/**
 * Timeline reutilizable de bitácora de auditoría.
 *
 * Props:
 * - logs: array de entradas { id, action, description, performedByName, createdAt, changes, metadata }
 * - loading?: boolean
 * - emptyText?: string
 * - showContract?: boolean  // muestra property/contrato si viene en la entrada
 */
const AuditLogTimeline = ({ logs = [], loading = false, emptyText = 'Sin operaciones registradas.', showContract = false }) => {
  if (loading) {
    return <div className={style.stateBox}>Cargando bitácora...</div>;
  }
  if (!logs.length) {
    return <div className={style.stateBox}>{emptyText}</div>;
  }

  return (
    <ul className={style.timeline}>
      {logs.map((log, idx) => {
        const meta = getMeta(log.action);
        const { Icon } = meta;
        const property = log.rental?.property || log.adminRental || null;
        return (
          <li key={log.id || idx} className={style.item}>
            <span className={style.dot} style={{ background: meta.color }}>
              <Icon />
            </span>
            <div className={style.body}>
              <div className={style.headRow}>
                <span className={style.badge} style={{ background: `${meta.color}1a`, color: meta.color }}>
                  {meta.label}
                </span>
                <span className={style.date}>{formatDateTime(log.createdAt)}</span>
              </div>
              {log.description && <p className={style.desc}>{log.description}</p>}
              {showContract && property && (
                <p className={style.contract}>
                  {property.address || property.propertyAddress || ''}
                </p>
              )}
              {log.performedByName && (
                <span className={style.author}>por {log.performedByName}</span>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default AuditLogTimeline;
